<template>
  <a-row justify="space-between">
    <a-col>
      <a-form layout="inline">
        <a-form-item label="姓名">
          <a-input
            placeholder="请输入姓名"
            v-model:value="formState.name"
          ></a-input>
        </a-form-item>
        <a-form-item label="邮箱">
          <a-input
            placeholder="请输入邮箱"
            v-model:value="formState.email"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-col>
    <a-col>
      <a-space>
        <a-button type="primary" @click="toQuery">查询</a-button>
        <a-button
          @click="
            () => {
              edit = false
              visible = true
            }
          "
          >新建用户</a-button
        >
      </a-space>
    </a-col>
  </a-row>
  <a-modal
    v-model:open="visible"
    :title="edit ? '编辑人员' : '新增人员'"
    :okText="edit ? '修改' : '新增'"
    @ok="onSubmit"
    @cancel="cancel"
  >
    <a-form
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="edit ? [] : rulesRef"
      ref="formRef"
      :model="modelRef"
    >
      <a-form-item label="姓名" name="name">
        <a-input v-model:value="modelRef.name" :disabled="edit"></a-input>
      </a-form-item>
      <a-form-item label="邮箱" name="email">
        <a-input v-model:value.trim="modelRef.email" :disabled="edit"></a-input>
      </a-form-item>
      <a-form-item label="密码" name="password">
        <a-input
          maxLength="60"
          v-model:value.trim="modelRef.password"
        ></a-input>
      </a-form-item>
      <a-form-item label="状态" name="state">
        <a-select v-model:value="modelRef.state">
          <a-select-option :value="0">启用</a-select-option>
          <a-select-option :value="1">停用</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      ...toRefs(inject('initState'))
    }
  }
}
</script>
